import React from 'react'
import PropTypes from 'prop-types'
import { css, cx } from '@linaria/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import { colors } from '../theme'

const feedbackTextCss = css`
  &[type='error'] {
    --special-type-color: ${colors.danger70};
    --special-type-secondary-color: ${colors.danger70};
  }
  &[type='warning'] {
    --special-type-color: ${colors.yellow60};
    --special-type-secondary-color: ${colors.yellow60};
  }
  &[type='complete'],
  &[type='ready'],
  &[type='confirmation'],
  &[type='success'] {
    --special-type-color: ${colors.green70};
    --special-type-secondary-color: ${colors.green70};
  }
  &[type='help'] {
    --special-type-color: ${colors.blue70};
    --special-type-secondary-color: ${colors.blue70};
  }

  &[with-white-text] {
    border-radius: 4px;
    --special-type-color: ${colors.gray100};
  }
`

export default function FeedbackText({ as: TagName = 'div', children, type, withWhiteText, className, ...props }) {
  return (
    <TagName
      {...props}
      className={cx(feedbackTextCss, className)}
      with-white-text={boolAttr(withWhiteText)}
      type={type}
    >
      {children}
    </TagName>
  )
}

FeedbackText.propTypes = {
  /** The text to style with feedback colors. */
  children: PropTypes.node.isRequired,

  /** The type of feedback this text is giving. Determines the color. */
  type: PropTypes.oneOf(['error', 'warning', 'success', 'help', 'ready', 'confirmation', 'complete', 'normal']),

  /** Ensures the text will have acceptable contrast. */
  withWhiteText: PropTypes.bool,
}
